import { FieldState, FormState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { EditInput } from "@fidget/common/components/form/editInput";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { validateUrl } from "@fidget/common/utils/validatorsFormState";
import { DiscardApplyButtons } from "../discardApplyButtons";
import styles from "./webhookField.css";

type UrlField = {
  url: FieldState<string>;
};

interface Props {
  initialValue: string;
  onSubmit: (url: string) => void;
}

@observer
export class WebhookField extends React.Component<Props> {
  form: FormState<UrlField>;

  constructor(props: Props) {
    super(props);

    this.form = new FormState({
      url: new FieldState(this.props.initialValue).validators(validateUrl)
    });
  }

  render() {
    const field = this.form.$.url;
    return (
      <form onSubmit={(ev) => ev.preventDefault()}>
        <div className={styles["input-container"]}>
          <div className={styles.inputLink}>
            <EditInput
              value={field.value}
              onChange={(e) => field.onChange((e.target as HTMLInputElement).value)}
              placeholder={intl.formatMessage("settings.webhooks.input.publicLink")}
              hasError={field.hasError}
              errorHint={field.error}
            />
          </div>
          <DiscardApplyButtons
            onApply={this.onSubmit}
            onDiscard={field.reset}
            hidden={!field.dirty}
          />
        </div>
      </form>
    );
  }

  onSubmit = async () => {
    const result = await this.form!.validate();
    if (!result.hasError) {
      this.props.onSubmit(result.value.url.$);
    }
  };
}
